<template>
    <section class="accountDetails">
		<Nav title="账户详情" />
        <section class="card_list">
            <div class="card">
                <div class="item">
                    <div class="label"><p>姓名</p></div>
                    <div class="info"><p>{{account.name}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>性别</p></div>
                    <div class="info">
                        <p v-if="account.gender == 1">男</p>
                        <p v-else-if="account.gender == 2">女</p>
                        <p v-else>未知</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>手机号</p></div>
                    <div class="info"><p>{{account.phoneNumber}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>身份证号</p></div>
                    <div class="info"><p>{{account.idCardNumber}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>邮箱</p></div>
                    <div class="info"><p>{{account.email || '-'}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>认证状态</p></div>
                    <div class="info">
                        <p v-if="account.authenticationStatus == 0">未认证</p>
                        <p v-if="account.authenticationStatus == 1">认证中</p>
                        <p v-if="account.authenticationStatus == 2">已认证</p>
                        <p v-if="account.authenticationStatus == 3">认证失败</p>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>账户编号</p></div>
                    <div class="info"><p>{{account.account}}</p></div>
                </div>
                <div class="item" v-if="account.accountType !=0">
                    <div class="label"><p>所属团队</p></div>
                    <div class="info"><p>{{account.teamName || '-'}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>账户类型</p></div>
                    <div class="info">
                        <p v-if="account.accountType == 0">机构管理员</p>
                        <p v-if="account.accountType == 1">团队管理员</p>
                        <p v-if="account.accountType == 2">业务员</p>
                    </div>
                </div>
                <div class="item" v-if="account.accountType == 2">
                    <div class="label"><p>自动接单开关</p></div>
                    <div class="info flex">
                        <p v-if="account.autoAcceptSwitch == 0">开启中</p>
                        <p v-if="account.autoAcceptSwitch == 1">已关闭</p>
                        <van-switch v-if="account.autoAcceptSwitch != -1" v-model="form.autoAcceptSwitch" active-color="#055CE8" inactive-color="#CED7E2" size=20 @change='onAutoAcceptSwitch' />
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>账户启停状态</p></div>
                    <div class="info flex">
                        <p v-if="account.status == 0">启用中</p>
                        <p v-if="account.status == 1">已停用</p>
                        <van-switch v-if="account.status != -1" v-model="form.status" active-color="#055CE8" inactive-color="#CED7E2" size=20 @change='onAccountStatusSwitch' :disabled='account.id == myAccountId || account.accountType==0' />
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>创建时间</p></div>
                    <div class="info"><p>{{account.gmtCreate}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>更新时间</p></div>
                    <div class="info"><p>{{account.gmtModify}}</p></div>
                </div>
            </div>                   
        </section>
        <section>
            <div class="button_area">
                <van-button round block type="primary" to="/team" native-type="submit">返回</van-button>                
            </div>
        </section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import { Toast } from 'vant';

import teamServer from "api/team";

export default {
    name: "accountDetails",
	components: {
		Nav,
	},
    data() {
        return {
            id: 0,
            account: {
                autoAcceptSwitch: -1,
                status: -1,
            },
            form: {},

            myAccountId: '',
		};
    },

    created() {
        this.id = this.$route.params.id
        this.getInfo();

        if(localStorage.getItem('accountInfoJSONString')) {
            this.myAccountId = JSON.parse(localStorage.getItem('accountInfoJSONString')).id
        }
	},

	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},	
    methods: {
        getInfo() {
            teamServer.getAccountDetails({id: this.id}).then((res) => {
                this.account = res.data

                this.form.autoAcceptSwitch = !this.account.autoAcceptSwitch
                this.form.status = !this.account.status
            })
        },

        onAutoAcceptSwitch() {
            teamServer.switchAutoAccept({id: this.id}).then((res) => {
                this.getInfo()
            })
        },

        onAccountStatusSwitch() {
            teamServer.switchAccountStatus({id: this.id}).then((res) => {
                this.getInfo()
            })
        },
    },
};
</script>

<style lang="scss">
	.accountDetails {
		padding-top: 46px;
		padding-bottom: 100px;

        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .item {
                margin-left: 30px;
                padding: 20px 30px 20px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;
                }

                .info.flex {
                    display: flex;
                    align-items: center;

                    p {
                        margin-right: 4px;
                    }
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .button_area {
            margin: 30px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/team/AccountDetails.vue